import { render, staticRenderFns } from "./HotelItem.vue?vue&type=template&id=04fe0ec3&"
import script from "./HotelItem.vue?vue&type=script&lang=ts&"
export * from "./HotelItem.vue?vue&type=script&lang=ts&"
import style0 from "./HotelItem.vue?vue&type=style&index=0&id=04fe0ec3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports